import * as fromDatatype from '../datatype-library/index';

export interface bl_mrp_pi_worklog_Rowinterface {
  guid: fromDatatype.GuidDataFieldInterface;
  machine_guid: fromDatatype.GuidDataFieldInterface;
  machine_code: fromDatatype.VarcharDatatypeInterface;
  process_instance_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pic_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  job_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  process_type_code: fromDatatype.VarcharDatatypeInterface;
  supervisor_remarks: fromDatatype.VarcharDatatypeInterface;
  qc_output_status: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  job_order_no: fromDatatype.VarcharDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  qc_input_status: fromDatatype.NumericDatatypeInterface;
  shift_date: fromDatatype.TimestampTzDatatypeInterface;
  shift_remarks: fromDatatype.VarcharDatatypeInterface;
  shift_type: fromDatatype.VarcharDatatypeInterface;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  end_time: fromDatatype.TimestampTzDatatypeInterface;
  total_time: fromDatatype.NumericDatatypeInterface;
  qty_produced: fromDatatype.NumericDatatypeInterface;
  total_qty_required: fromDatatype.NumericDatatypeInterface;
  total_qty_produced: fromDatatype.NumericDatatypeInterface;
  production_rate: fromDatatype.NumericDatatypeInterface;
  qty_produced_discrepancy: fromDatatype.NumericDatatypeInterface;
  production_rate_material_uom: fromDatatype.VarcharDatatypeInterface;
  production_rate_time_uom: fromDatatype.VarcharDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  custom_attribute_json: any;
  custom_quantifiable_attribute_json: any;
  property_json: any;
  length_cutting_json: any;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: any;
  acl_policy: any;
}

export class bl_mrp_pi_worklog_Rowclass implements bl_mrp_pi_worklog_Rowinterface {
  guid: fromDatatype.GuidDataFieldInterface;
  machine_guid: fromDatatype.GuidDataFieldInterface;
  machine_code: fromDatatype.VarcharDatatypeInterface;
  process_instance_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pic_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  job_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  process_type_code: fromDatatype.VarcharDatatypeInterface;
  supervisor_remarks: fromDatatype.VarcharDatatypeInterface;
  qc_output_status: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  job_order_no: fromDatatype.VarcharDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  qc_input_status: fromDatatype.NumericDatatypeInterface;
  shift_date: fromDatatype.TimestampTzDatatypeInterface;
  shift_remarks: fromDatatype.VarcharDatatypeInterface;
  shift_type: fromDatatype.VarcharDatatypeInterface;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  end_time: fromDatatype.TimestampTzDatatypeInterface;
  total_time: fromDatatype.NumericDatatypeInterface;
  qty_produced: fromDatatype.NumericDatatypeInterface;
  total_qty_required: fromDatatype.NumericDatatypeInterface;
  total_qty_produced: fromDatatype.NumericDatatypeInterface;
  production_rate: fromDatatype.NumericDatatypeInterface;
  qty_produced_discrepancy: fromDatatype.NumericDatatypeInterface;
  production_rate_material_uom: fromDatatype.VarcharDatatypeInterface;
  production_rate_time_uom: fromDatatype.VarcharDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  custom_attribute_json: any;
  custom_quantifiable_attribute_json: any;
  property_json: any;
  length_cutting_json: any;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: any;
  acl_policy: any;
}